import { render, staticRenderFns } from "./DiretoriaSettings.vue?vue&type=template&id=3c6358f5"
import script from "./DiretoriaSettings.vue?vue&type=script&lang=js"
export * from "./DiretoriaSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports